import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { resilienceApi, type RecoveryPlan } from '../../api/resilience';

export function RecoveryRunbooksPage() {
  const [plans, setPlans] = useState<RecoveryPlan[]>([]);
  useEffect(() => { void resilienceApi.listRecoveryPlans().then(setPlans); }, []);
  return (
    <div className="mx-auto max-w-6xl p-6">
      <h1 className="text-2xl font-semibold dark:text-slate-100">Recovery Runbooks</h1>
      <Link to="/resilience" className="mt-2 inline-block text-sm text-emerald-700 hover:underline dark:text-emerald-400">← Resilience Hub</Link>
      <div className="mt-6 space-y-4">{plans.map((p) => (
        <div key={p.id} className="rounded-xl border p-4 dark:border-slate-700">
          <p className="font-medium">{p.name}</p>
          <ol className="mt-2 list-decimal pl-5 text-sm text-slate-600 dark:text-slate-400">{p.steps?.map((s, i) => <li key={i}>{s}</li>)}</ol>
        </div>
      ))}</div>
    </div>
  );
}
